import convertDegreesToRadians from "./degressToradians";

/**
 * Calculates the distance in miles between two geographic coordinates.
 *
 * @param {number} originLatitude - The latitude of the first coordinate in degrees.
 * @param {number} originLongitude - The longitude of the first coordinate in degrees.
 * @param {number} targetLatitude - The latitude of the second coordinate in degrees.
 * @param {number} targetLongitude - The longitude of the second coordinate in degrees.
 * @returns {number} The distance in miles between the two coordinates.
 */
export default function getDistanceBetweenCoordinates(
    originLatitude, 
    originLongitude, 
    targetLatitude, 
    targetLongitude
  ) {
  const earthRadius = 3959; // Radius of the earth in miles
  const deltaLatitude = convertDegreesToRadians(targetLatitude - originLatitude);
  const deltaLongitude = convertDegreesToRadians(targetLongitude - originLongitude);

  /**
   * Calculates an intermediate value used in the distance calculation between two geographic coordinates.
   *
   */
  const haversineFormula = 
    Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
    Math.cos(convertDegreesToRadians(originLatitude)) * Math.cos(convertDegreesToRadians(targetLatitude)) *
    Math.sin(deltaLongitude / 2) * Math.sin(deltaLongitude / 2);
  const centralAngle = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));
  const distance = earthRadius * centralAngle; // Distance in miles
  return distance;
}